import { PRODUCT_TYPES } from '../lib/constants';
// ---- internal imports ------

import ProductPurchasesLogBuilder from './product-purchases-log';
// ---- local imports ------

class PurchasesLog {
	constructor(tablePurchasesLog, chairPurchasesLog, couchPurchasesLog) {
		this.tablePurchasesLog = tablePurchasesLog;
		this.chairPurchasesLog = chairPurchasesLog;
		this.couchPurchasesLog = couchPurchasesLog;
	}

	toPlainObj() {
		return {
			[PRODUCT_TYPES.TABLE]: this.tablePurchasesLog.toPlainObj(),
			[PRODUCT_TYPES.CHAIR]: this.chairPurchasesLog.toPlainObj(),
			[PRODUCT_TYPES.COUCH]: this.couchPurchasesLog.toPlainObj()
		};
	}
};

export default function PurchasesLogBuilder() {
	return {
		withTablePurchasesLog: function (amount, cost) {
			this.tablePurchasesLog = new ProductPurchasesLogBuilder()
				.withAmount(amount)
				.withCost(cost)
				.build();
			return this;
		},
		withChairPurchasesLog: function (amount, cost) {
			this.chairPurchasesLog = new ProductPurchasesLogBuilder()
				.withAmount(amount)
				.withCost(cost)
				.build();
			return this;
		},
		withCouchPurchasesLog: function (amount, cost) {
			this.couchPurchasesLog = new ProductPurchasesLogBuilder()
				.withAmount(amount)
				.withCost(cost)
				.build();
			return this;
		},
		build: function () {
			return new PurchasesLog(
				this.tablePurchasesLog, 
				this.chairPurchasesLog, 
				this.couchPurchasesLog
			);
		}
	};
}

export function getNewEmptyPurchasesLogObj() {
	return new PurchasesLogBuilder()
		.withTablePurchasesLog(0, 0)
		.withChairPurchasesLog(0, 0)
		.withCouchPurchasesLog(0, 0)
		.build()
		.toPlainObj();
}
